import styled from 'styled-components'

import { Link as LinkBase } from '@src/Application/Interfaces/Atoms/Link'

export const Wrapper = styled.div`
    padding: 50px 20px;
    background-color: ${(props) => props.theme.color.g100};

    &:nth-child(even) {
        background-color: ${(props) => props.theme.color.white};
    }

    @media ${(props) => props.theme.query.min.tablet} {
        padding: 100px 0px;
    }
`

export const Title = styled.h3`
    ${(props) => props.theme.typo.bodyL};
    ${(props) => props.theme.fontWeight.regular};
    color: ${(props) => props.theme.color.p500};
    text-align: center;
    margin-bottom: 30px;

    @media ${(props) => props.theme.query.min.tablet} {
        ${(props) => props.theme.typo.displayXL};
        margin-bottom: 50px;
    }
`

export const Link = styled(LinkBase)`
    ${(props) => props.theme.typo.bodyM};
    ${(props) => props.theme.fontWeight.regular};
    color: ${(props) => props.theme.color.g600};
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
`
